var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetiremnetNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3019 47.3513C49.9403 47.3513 49.708 45.5704 45.2171 44.3702C42.0811 43.5185 38.1322 43.2862 34.2994 43.712C33.4477 43.8282 33.1767 42.6667 33.7961 42.3183L31.9378 37.5563C31.0086 37.6338 30.815 36.1626 31.7829 36.0464C39.4098 34.8463 48.7401 35.6593 54.741 40.2277C57.7608 42.5506 56.1347 47.3513 52.3019 47.3513Z",
    fill: "#445174"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9775 73.4456C37.6678 73.4456 37.2806 73.252 37.2419 72.8261L33.9124 71.5485C33.2155 71.9744 32.4025 71.2001 32.7897 70.5032L38.8292 60.1663C39.1777 59.5469 39.952 59.7791 40.1842 60.2824L44.2881 60.3986C44.9849 59.2371 46.1851 60.2437 45.7205 61.0567L38.6744 73.0584C38.5195 73.3294 38.2485 73.4456 37.9775 73.4456Z",
    fill: "#AF8EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3548 74.9548C59.7741 74.9548 59.6193 74.4515 59.3095 73.9482L51.4116 60.3592C50.9471 59.5849 52.1085 58.5009 52.8441 59.7785L56.6382 59.4688C56.7543 58.8493 57.6835 58.5009 58.1094 59.1978L65.8137 72.5158C66.2008 73.2126 65.3104 74.1805 64.5361 73.2901L61.1291 74.3354C61.0517 74.6838 60.742 74.9548 60.3548 74.9548Z",
    fill: "#AF8EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7173 65.3541C65.2717 65.3541 64.2651 61.2116 60.5484 60.3599C59.0385 60.0114 50.4438 60.9019 49.2049 61.018C37.9001 62.2569 33.7576 62.0633 29.344 50.3714L20.246 26.2131C19.4717 24.1612 20.517 21.877 22.5689 21.1027C24.6208 20.3284 26.905 21.3737 27.6793 23.4256L37.1645 48.5905C38.7905 52.8878 39.41 54.4752 45.527 53.4299C48.7016 52.9266 59.3483 51.92 62.3293 52.6168C65.2717 53.275 70.4595 56.5658 72.1242 59.3146C73.7116 61.9859 71.7371 65.3541 68.7173 65.3541Z",
    fill: "#C8CCD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9926 80.607C44.0173 80.607 36.0033 78.5551 28.9184 74.8772C26.9826 73.8706 25.4727 72.9414 24.2726 72.0897C22.8788 71.0444 22.5691 69.0312 23.6144 67.6375C24.621 66.205 26.6342 65.8953 28.0279 66.9406C31.7446 69.6894 38.0164 72.0897 42.2364 73.0963C53.5412 75.8064 64.8847 73.7545 75.1055 67.2116C76.5767 66.2437 78.5512 66.6696 79.4803 68.1408C80.4482 69.6119 80.0223 71.5864 78.5512 72.5543C70.1887 77.897 61.1681 80.607 51.9926 80.607Z",
    fill: "#C8CCD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetiremnetNew);
export default __webpack_public_path__ + "static/media/RetiremnetNew.d8490586bc694530d18dd33ecdaeff16.svg";
export { ForwardRef as ReactComponent };